import React from 'react';
import ExternalLinkIcon from 'adp-react-icons/lib/fa/external-link';
import PropTypes from 'prop-types';
import './footer.scss';


class Footer extends React.Component{


  updatedCopyRightYear(oldStr){
    return oldStr.replace("2019", new Date().getFullYear());
  }

  render() {
    let copyright ='';
    if(this.props.copyright !='udefined' && this.props.copyright!=null && this.props.copyright !=''){
      copyright = this.updatedCopyRightYear(this.props.copyright);
    }
    return (
      <footer className="vdl-footer">
        <ul>
          <li>
            <a href={this.props.privacylocale} target="_blank">
              <ExternalLinkIcon />
              {this.props.privacy}
            </a>
          </li>
          <li>
            <a href={this.props.legallocale} target="_blank">
              <ExternalLinkIcon />
              {this.props.legal}
            </a>
          </li>
          <li className="copyright">
          { copyright }
          </li>
        </ul>
      </footer>
    );
  }

}

Footer.propTypes= {
  copyright: PropTypes.string,
  privacy: PropTypes.string,
  legal: PropTypes.string,
  privacylocale: PropTypes.string,
  legallocale: PropTypes.string

};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/footer.js